import React from 'react';
import ComingSoon from './ComingSoon';
import Subscription from '../Subscription Plan/Subscription.jsx'
import { useEffect } from "react";

const ProfileSubscription = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  return <Subscription />;
};

export default ProfileSubscription;
